import React, { Component } from 'react';
import { Col,  Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import AdminPrivateEventList from '../components/admin/AdminPrivateEventList';
import '../css/style.css';
import '../components/Home.css';



class AdminActivityLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="6">
                <Row>
                    <Col >
                    <AdminPrivateEventList  eventType={'ACTIVITY'}/>
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default AdminActivityLayout;